import angular from 'angular';

angular.module('cloudX').directive('rowBlur', [
  '$timeout',
  '$parse',
  function($timeout, $parse) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if (!attrs.rowBlur) return;
        var extBlur = $parse(attrs.rowBlur);
        if (!extBlur) return;

        var focusedElement = null;
        var onFocus = function() {
          var self = this;
          if (focusedElement !== self) {
            focusedElement = self;
            $timeout(function() {
              if (!focusedElement) extBlur();
            }, 10);
          }
        };
        var onBlur = function() {
          focusedElement = null;
        };

        var elements = $('input,select,textarea', element);

        elements.on('focus', onFocus);
        elements.on('blur', onBlur);

        //Cleanup events if the element is destroyed
        element.on('$destroy', function() {
          elements.off('focus', onFocus);
          elements.off('blur', onBlur);
          focusedElement = null;
        });
      },
    };
  },
]);
